import axios from 'axios';
import { isAuthed, logout } from './auth';

// 401 nestes endpoints e' "senha errada", nao "sessao expirada" — nao desloga.
const AUTH_ENDPOINTS = ['/rest/V1/integration/admin/token', '/picking-extras/login.php'];
let isHandlingUnauthorized = false;

const shouldSkipUnauthorizedHandling = (url = '') =>
  AUTH_ENDPOINTS.some((endpoint) => url.includes(endpoint));

const handleUnauthorized = (requestUrl = '') => {
  if (isHandlingUnauthorized) return;
  if (!isAuthed()) return;
  if (shouldSkipUnauthorizedHandling(requestUrl)) return;

  isHandlingUnauthorized = true;
  logout();
  // allow new sessions to trigger logout again after re-auth
  setTimeout(() => {
    isHandlingUnauthorized = false;
  }, 0);
};

if (typeof window !== 'undefined' && typeof window.fetch === 'function') {
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const requestUrl =
      typeof args[0] === 'string'
        ? args[0]
        : typeof args[0] === 'object' && args[0] !== null
        ? args[0].url || ''
        : '';

    if (response && (response.status === 401 || response.status === 403)) {
      handleUnauthorized(requestUrl);
    }

    return response;
  };
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      handleUnauthorized(error?.config?.url || '');
    }
    return Promise.reject(error);
  }
);
